module.exports = __webpack_public_path__ + "img/icon-search-secondary.f7a524f1.svg";